/* global axios */
import ApiClient from './ApiClient';

class FormsAPI extends ApiClient {
  constructor() {
    super('forms', { accountScoped: true });
  }

  create(form) {
    return axios.post(this.url, { form });
  }

  update(id, form) {
    return axios.patch(`${this.url}/${id}`, { form });
  }

  // F3.2 — resumo de conversão (views/conclusão/funil por passo) do form.
  analytics(id) {
    return axios.get(`${this.url}/${id}/analytics`);
  }

  // Onda 1 do módulo: a lista das respostas e a planilha, que é a primeira
  // coisa que o dono do formulário procura.
  submissions(id, page = 1) {
    return axios.get(`${this.url}/${id}/submissions`, { params: { page } });
  }

  // Pelo axios, que leva o token do painel: abrir a URL numa aba dava 401.
  // Blob preserva o BOM que o Excel usa para ler os acentos.
  submissionsExport(id) {
    return axios.get(`${this.url}/${id}/submissions_export`, {
      responseType: 'blob',
    });
  }

  uploadImage(id, kind, file) {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('kind', kind);
    return axios.post(`${this.url}/${id}/upload_image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new FormsAPI();
